import {axiosGetAuthorize, axiosPostAuthorize} from '../AxiosRequests';
import {AddEmailTemplates,UpdateEmailTemplates,GetEmailTemplateById,GetEmailTemplatesList,DeleteEmailTemplates,GetEmailTemplatesListByEmailTypeId,GetEmailTypesList} from '../ApiEndPoints';

export default class EmailTemplateServices {

    //** Call API : Get Email Template List */
    async addEmailTemplates(request){
        return axiosPostAuthorize(AddEmailTemplates, request);
    }
     
    async updateEmailTemplates(request){
        return axiosPostAuthorize(UpdateEmailTemplates, request);
    }

    async deleteEmailTemplates(request){
        return axiosPostAuthorize(DeleteEmailTemplates,request);
    }


    async getEmailTemplatesList(request){
        return axiosPostAuthorize(GetEmailTemplatesList, request);
    }

    async getEmailTemplateById(request) {
        return axiosGetAuthorize(GetEmailTemplateById, request);
    }

    async getEmailTemplateById(request) { //duplicate
        return axiosGetAuthorize(GetEmailTemplateById, request);
    }
    async getEmailTemplatesListByEmailTypeId(request) {
        return axiosGetAuthorize(GetEmailTemplatesListByEmailTypeId, request);
    }

    async getEmailTypesList(request){
        return axiosGetAuthorize(GetEmailTypesList, request);
    }
}